import React, { useMemo } from 'react';
import noop from 'lodash/noop';
import ScreenSpaceFlags from '@post-office-placement/screen-space-flags/placement';
import { fg } from '@atlassian/jira-feature-gating';
import { useFlagsService } from '@atlassian/jira-flags';
import killswitch from '@atlassian/jira-killswitch/src/index.tsx';
import Placement from '@atlassian/post-office-placement/placement';
import { ScreenSpaceFlagPlacementPreviewSwitcher } from '@atlassian/post-office-placement/preview';
import { POST_OFFICE_KILL_SWITCH } from './constants.tsx';

const PLACEMENT_ID = 'screen-space-flags';

// NOTE: Do not clean up this FF. It has overrides configured that restrict several jira
// pollinator bot accounts from bombarding PO with requests and causing Stargate rate
// limit alerts. Until we have a permanent solution, this FF has been marked as a permanent
// feature gate in Statsig.
// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/post-office-screen-space-overlay-jfe
export const ScreenSpaceFlagsPlacement = () => {
	const flagsService = fg('inject_jira_feature_flags_service_into_post_office')
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useFlagsService()
		: {
				dismissFlag: noop,
				hasFlag: noop,
				showFlag: noop,
			};

	const stablePlacementProps = useMemo(
		() => ({
			jiraFlagsService: {
				dismissFlag: flagsService.dismissFlag,
				hasFlag: flagsService.hasFlag,
				showFlag: flagsService.showFlag,
			},
		}),
		[flagsService?.dismissFlag, flagsService?.hasFlag, flagsService?.showFlag],
	);

	return !__SERVER__ &&
		!killswitch(POST_OFFICE_KILL_SWITCH) &&
		fg('post-office-screen-space-overlay-jfe') ? (
		<ScreenSpaceFlagPlacementPreviewSwitcher
			// https://switcheroo.atlassian.com/ui/gates/8fe500fb-6c32-48c7-be3f-caf511e97a8e/key/post-office_enable_screen-space-preview_jfe
			isEnabled
		>
			<Placement
				placementId={PLACEMENT_ID}
				PlacementComponent={ScreenSpaceFlags}
				disableInitialData
				{...(fg('inject_jira_feature_flags_service_into_post_office')
					? { placementProps: stablePlacementProps }
					: undefined)}
			/>
		</ScreenSpaceFlagPlacementPreviewSwitcher>
	) : null;
};
